import { indexToTime } from "./timeIndex";

/**
 * Place on the pane → point of a drawing, free in both directions.
 *
 * @param {{ x: number, y: number }} pixel - CSS px of the pane
 * @param {object} view - see createDrawings
 * @returns {{ time: number, price: number } | null} null when there are no bars
 */
export const pixelToPoint = ({ x, y }, { store, barDurationMs, timeScale, priceScale }) => {
  const time = indexToTime(timeScale.xToIndex(x), store, barDurationMs);

  return time === null ? null : { time, price: priceScale.yToPrice(y) };
};
